import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/caldorus-horizon/caldorus-horizon/node_modules/next/dist/client/app-dir/link.js");
